// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7c621f3a","667":"e03b00c4","977":"515a8541"}[chunkId] + ".chunk.js";
};